import BaseModel from '../base';

export default class AwardSettings extends BaseModel {
  constructor(settings = {}, url = '') {
    super(settings, url);

    this.prize_places_count = settings.prize_places_count;
    this.prize_winners_places = settings.prize_winners_places;
  }
}
